module.exports = __webpack_public_path__ + "static/media/e&oHead2.846a6fce.png";